// Paths relative to /api/v1, exactly as published in the Core OpenAPI.
export const taskPaths = {
    list: () => 'admin/tasks',
    detail: (id) => `admin/tasks/${id}`,
    reviewRounds: (id) => `admin/tasks/${id}/review-rounds`,
    decision: (id) => `admin/tasks/${id}/review-round/decision`,
};

export const eventPaths = {
    list: () => 'admin/events',
};

export const coordinationPaths = {
    seats: () => 'admin/coordination/seats',
    attention: () => 'admin/attention',
};
